/**
 * Flatten `campaign.campaign_images[]` into macro-friendly URLs keyed by `creative_type`
 * (e.g. `icon_image`, `hero_image`) for COU templates.
 */
const KNOWN_CREATIVE_TYPES = [
    'icon_image',
    'hero_image',
    'offer_image',
];
function urlForCreativeType(images, creativeType) {
    const want = creativeType.toLowerCase();
    for (const item of images) {
        if (!item || typeof item !== 'object') {
            continue;
        }
        const rec = item;
        const ct = String(rec.creative_type ?? '').toLowerCase();
        if (ct !== want) {
            continue;
        }
        const u = rec.url;
        if (u != null && String(u).trim() !== '') {
            return String(u);
        }
    }
    return '';
}
/**
 * Adds URL strings for common `creative_type` values found in `campaign_images`.
 * First match wins per type. Missing arrays keep extras empty-string so `{{#if hero_image}}` is falsy.
 */
export function withCreativeTypeImageMacros(attrs) {
    const raw = attrs.campaign_images;
    if (!Array.isArray(raw)) {
        return { ...attrs };
    }
    const extras = {};
    for (const key of KNOWN_CREATIVE_TYPES) {
        extras[key] = urlForCreativeType(raw, key);
    }
    return { ...attrs, ...extras };
}
/**
 * Adds `publisher_image_N` macros (one per entry, in array order) from
 * `campaign.publisher_campaign_images`, plus a `publisher_image` alias for the first
 * entry. Missing sources keep these keys unset so `{{#if publisher_image}}` stays
 * falsy.
 */
export function withPublisherImageMacros(attrs) {
    const extras = {};
    const raw = attrs.publisher_campaign_images;
    if (Array.isArray(raw) && raw.length > 0) {
        raw.forEach((item, index) => {
            const url = item && typeof item === 'object'
                ? String(item.url ?? '')
                : '';
            extras[`publisher_image_${index + 1}`] = url;
        });
        extras.publisher_image = extras.publisher_image_1;
    }
    return { ...attrs, ...extras };
}
